// src/utils/deviceId.js
// Stable per-device identifier — persisted in localStorage.
// Used for SOS dedup and report attribution.
// NOT a user ID — rotates if localStorage is cleared.

const KEY = 'eos_device_id';

function generate() {
  return 'dev_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) { id = generate(); localStorage.setItem(KEY, id); }
    return id;
  } catch {
    return generate(); // private browsing fallback
  }
}
